// extracted by mini-css-extract-plugin
module.exports = {"pt-user-setting":"pt-user-setting-7143f5226e4a7fa1d485df0751e080e1","global":"global-078189cac5fc10afb386d859ec93df9d","icon-xuanze":"icon-xuanze-e3625b97d6069de232b8d08e4e8b4722"};